import type { LoadingStateSize } from './types'

/**
 * Минимальная высота зоны ожидания, чтобы контент не «прыгал» при появлении. Сверх неё зона
 * растягивается на всю доступную высоту (см. модуль стилей) — на пустом экране кольцо тогда
 * оказывается ровно посередине, а не прижатым к верху.
 */
export const LOADING_STATE_MIN_HEIGHT: Record<LoadingStateSize, number> = {
  S: 64,
  M: 140,
  L: 260,
}
